(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /* Séfia — panier compact : recopie le total du panier dans le bouton "Commander · total"
     après chaque mise à jour du panier. Ne fait rien si les éléments sont absents. */
  (function () {
    function syncTotal(scope) {
      var target = scope.querySelector('.cart-drawer__cta-total-value');
      var source = scope.querySelector('.cart__total-raw');
      if (!target || !source) return;
      var value = (source.textContent || '').trim();
      if (value && target.textContent !== value) target.textContent = value;
    }

    function watch(drawer) {
      var root = drawer.closest('.shopify-section') || drawer.parentElement;
      if (!root || root.dataset.sefiaTotalWatch) return;
      root.dataset.sefiaTotalWatch = 'true';
      var scheduled = false;
      syncTotal(root);
      new MutationObserver(function () {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(function () {
          scheduled = false;
          syncTotal(root);
        });
      }).observe(root, { childList: true, subtree: true, characterData: true });
    }

    function init() {
      document.querySelectorAll('cart-drawer.cart-drawer--total-in-cta').forEach(watch);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-timeline"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function init(root) {
      root.querySelectorAll('.tl-wrap').forEach(function(wrap) {
        wrap.querySelectorAll('.tl-step').forEach(function(step) {
          var head = step.querySelector('.tl-head');
          if (!head) return;
          head.addEventListener('click', function() {
            var wasActive = step.classList.contains('active');
            wrap.querySelectorAll('.tl-step').forEach(function(s) {
              s.classList.remove('active');
            });
            if (!wasActive) step.classList.add('active');
          });
        });
      });
    }
    init(document);
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function(e) { init(e.target); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
